module.exports = __webpack_public_path__ + "static/securedapp-section-img-f931c4244a943de9f2634443c1145244.webp";